
/**
 *	settings:
 *
 *	Allgemeine states, die von verschiedenen components / views
 *	benötigt werden.
 *
 * 	Beispiel zum Ändern eines globalen Wertes von einer Komponente aus:
 * 	this.$store.commit('settings/SET_CONFIG', obj);
 * 
 * 	Zugriff auf Wert aus Komponente:
 * 	this.$store.state.settings
 * 
 * 	Alternativ mapState() verwenden:
 * 	import { mapState } from 'vuex';
 * 	computed: {
 * 		...mapState('settings', ['config']),
 * 	}
 * 	Zugriff: this.config
 * 	
 */

export const state = {
	config: {},
}

export const mutations = {

	SET_CONFIG (state, config ) {
		state.config = config;
	},

}

export const actions = {
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
